import React from "react";

// Inline styles rather than SCSS: these two pages are the only public,
// logged-out surfaces in the app and must render correctly before any of the
// dashboard stylesheets load. Palette follows the Beam tokens.
export const styles: { [key: string]: React.CSSProperties } = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#EFF2F7",
    padding: 20,
  },
  card: {
    width: "100%",
    maxWidth: 380,
    background: "#FFFFFF",
    borderRadius: 10,
    padding: 30,
    textAlign: "center",
    boxShadow: "5px 5px 8px rgba(203, 217, 240, 0.3)",
  },
  avatar: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    objectFit: "cover",
    marginBottom: 16,
  },
  avatarFallback: {
    width: 72,
    height: 72,
    borderRadius: "50%",
    background: "#F5F6F9",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 16,
  },
  avatarInitial: { fontSize: 30, fontWeight: 700, color: "#869cbd" },
  title: {
    fontSize: 24,
    lineHeight: "34px",
    color: "#000000",
    fontWeight: 700,
    margin: "0 0 8px",
  },
  body: {
    fontSize: 14,
    lineHeight: "20px",
    color: "#566477",
    margin: "0 0 24px",
  },
  codeBox: {
    background: "#F5F6F9",
    border: "1px solid #C5D2E9",
    borderRadius: 10,
    padding: "12px 10px",
    marginBottom: 20,
  },
  codeLabel: {
    display: "block",
    fontSize: 11,
    lineHeight: "16px",
    color: "#91A5C6",
    marginBottom: 2,
  },
  code: {
    display: "block",
    fontSize: 20,
    lineHeight: "28px",
    letterSpacing: 2,
    fontWeight: 900,
    color: "#000000",
  },
  primaryBtn: {
    display: "block",
    width: "100%",
    background: "#508AFA",
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: 700,
    border: "none",
    borderRadius: 10,
    padding: "14px 16px",
    cursor: "pointer",
    marginBottom: 12,
  },
  secondaryBtn: {
    display: "block",
    width: "100%",
    background: "#FFFFFF",
    color: "#566477",
    fontSize: 15,
    fontWeight: 700,
    border: "1px solid #d0daea",
    borderRadius: 10,
    padding: "12px 16px",
    cursor: "pointer",
  },
  footnote: {
    fontSize: 12,
    lineHeight: "17px",
    color: "#91A5C6",
    margin: "20px 0 0",
  },
  error: {
    fontSize: 13,
    lineHeight: "18px",
    color: "#FF5F25",
    margin: "0 0 16px",
  },
  spinner: {
    fontSize: 14,
    color: "#566477",
    margin: "20px 0",
  },
};
